import { makeRequest } from '../../../../../api/makeRequest';

export const getIncomingInvite = () => makeRequest({
  url: '/customers/products/mobile/profile/getincominginviteLk/',
  headers: {
    'content-type': 'application/json',
  },
});
